import { UserData } from "../types/user";

export const STORAGE_KEYS = {
  JWT_TOKEN: "jwtToken",
  REFRESH_TOKEN: "refreshToken",
  USER_EMAIL: "userEmail",
  USER_DATA: "userData",
} as const;

export const storage = {
  getJwtToken: (): string | null => {
    try {
      return localStorage.getItem(STORAGE_KEYS.JWT_TOKEN);
    } catch (error) {
      console.error("Error getting JWT token:", error);
      return null;
    }
  },

  setJwtToken: (token: string): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.JWT_TOKEN, token);
    } catch (error) {
      console.error("Error setting JWT token:", error);
    }
  },

  getRefreshToken: (): string | null => {
    try {
      return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    } catch {
      return null;
    }
  },

  setRefreshToken: (token: string): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token);
    } catch (error) {
      console.error("Error setting refresh token:", error);
    }
  },

  clearRefreshToken: (): void => {
    try {
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    } catch {
      /* ignore */
    }
  },

  getUserEmail: (): string | null => {
    try {
      return localStorage.getItem(STORAGE_KEYS.USER_EMAIL);
    } catch (error) {
      console.error("Error getting user email:", error);
      return null;
    }
  },

  setUserEmail: (email: string): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.USER_EMAIL, email);
    } catch (error) {
      console.error("Error setting user email:", error);
    }
  },

  getUserData: (): UserData | null => {
    try {
      const data = localStorage.getItem(STORAGE_KEYS.USER_DATA);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error("Error getting user data:", error);
      return null;
    }
  },

  setUserData: (data: UserData): void => {
    try {
      localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(data));
    } catch (error) {
      console.error("Error setting user data:", error);
    }
  },

  clear: (): void => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error("Error clearing storage:", error);
    }
  },

  removeItem: (key: keyof typeof STORAGE_KEYS): void => {
    try {
      localStorage.removeItem(STORAGE_KEYS[key]);
    } catch (error) {
      console.error(`Error removing ${key}:`, error);
    }
  },
};
